import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "card-header border-0 pt-5"
}
const _hoisted_2 = { class: "card-title align-items-start flex-column" }
const _hoisted_3 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_4 = {
  key: 0,
  class: "text-muted fw-bold fs-7"
}
const _hoisted_5 = {
  key: 0,
  class: "card-toolbar",
  "data-kt-buttons": "true"
}

import LoadingScreen from "@/components/LoadingScreen.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Card',
  props: {
    widgetClasses: {},
    bodyClass: {},
    title: {},
    subtitle: {},
    loading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses || '', "card"])
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(LoadingScreen, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.title || _ctx.$slots.header || _ctx.$slots.toolbar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "header", {}, () => [
            _createElementVNode("h3", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1),
              (_ctx.subtitle)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.subtitle), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.$slots.toolbar)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "toolbar")
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["card-body", _ctx.bodyClass])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 2))
}
}

})